module.exports = __webpack_public_path__ + "static/media/C2.b3b9756f.jpg";